module.exports = "data:application/octet-stream;base64,QGltcG9ydCB1cmwoJ2h0dHBzOi8vZm9udHMuZ29vZ2xlYXBpcy5jb20vY3NzP2ZhbWlseT1CaXR0ZXInKTsKCi5BcHAgewogIHRleHQtYWxpZ246IGNlbnRlcjsKICBtYXJnaW46IDdlbSAuNWVtOwogIGJhY2tncm91bmQtY29sb3I6ICNmZmY7Cn0K"


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 640
// module chunks = 0